import React from "react";
import { observer, inject } from "mobx-react";
import "./Images.scss";
import ImagesStore from "./ImagesStore";
import Widget from "../Widget";

class Images extends Widget {
  constructor(props) {
    super(props);
    this.store = new ImagesStore();
  }

  render() {
    return <div className="images widget"></div>;
  }
}

export default inject("store")(observer(Images));
